export default "__VITE_ASSET__BIwYPVVL__"